interface ImageProps {
    src: string;
    className?: string;
}

import { useState } from 'react';
import animData from './thumb_loading.json';
import Lottie from 'react-lottie';
export const ImageUI = (props: ImageProps) => {
    const [isLoaded, setIsLoaded] = useState(false);

    const defaultOptionsLottie = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: animData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <>
            {!isLoaded && (
                <div className={props.className}>
                    <Lottie options={defaultOptionsLottie} />
                </div>
            )}

            <img
                src={props.src}
                alt="placeholder"
                className={props.className}
                onLoad={() => {
                    setIsLoaded(true);
                }}
            />
        </>
    );
};
